import React from 'react';

import {Icon} from '@chakra-ui/react';
import {
    MdBarChart,
    MdMoney,
    MdHome,
    MdLock,
    MdOutlineShoppingCart,
    MdHourglassEmpty,
    MdProductionQuantityLimits
} from 'react-icons/md';

import MainDashboard from 'views/admin/default';
import Orders from 'views/admin/orders';
import PartialOrders from 'views/admin/partials';
import Products from 'views/admin/products';
import Roas from 'views/admin/roas';
import Calculator from 'views/admin/calculator';
import Form from 'views/admin/forms';
import LandingPageBuilder from 'views/admin/landingPages';
import ProductForm from 'views/admin/products/ProductForm';
import Profile from 'views/admin/profile';

import SignInCentered from 'views/auth/signIn';
import Settings from "./views/admin/settings";
import ChangePassword from "./views/admin/changePassword";
import EmployeesModule from "./views/admin/team";
import LinkAccount from "./views/admin/linkAccount";
import AcceptAccount from "./views/admin/linkAccount/Accept";
import Forbidden from "./views/admin/forbidden";

const routes = [
    {
        name: 'Main Dashboard',
        nameKey: 'routes.mainDashboard',
        layout: '/admin',
        path: '/default',
        icon: <Icon as={MdHome} width="20px" height="20px" color="inherit"/>,
        component: <MainDashboard/>,
        permission: 'basic-default',
        employeePermission: 'access-dashboard-page',
    },
    {
        name: 'Orders',
        nameKey: 'routes.orders',
        layout: '/admin',
        path: '/orders',
        icon: (
            <Icon
                as={MdOutlineShoppingCart}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: <Orders />,
        permission: 'basic-default',
        employeePermission: 'access-orders-page',
    },
    {
        name: 'Partial Orders',
        nameKey: 'routes.partialOrders',
        layout: '/admin',
        path: '/partial-orders',
        icon: (
            <Icon
                as={MdHourglassEmpty}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: <PartialOrders />,
        permission: 'basic-default',
        employeePermission: 'access-partials-page',
    },
    {
        name: 'Products',
        nameKey: 'routes.products',
        layout: '/admin',
        path: '/products',
        icon: (
            <Icon
                as={MdProductionQuantityLimits}
                width="20px"
                height="20px"
                color="inherit"
            />
        ),
        component: <Products />,
        permission: 'basic-default',
        employeePermission: 'access-products-page',
    },
    {
        dontShow: true,
        name: 'Edit Form',
        nameKey: 'routes.editForm',
        layout: '/admin',
        path: '/forms/:formId/:productId',
        component: <Form />,
        employeePermission: 'edit-forms',
    },
    {
        dontShow: true,
        name: 'Create Form',
        nameKey: 'routes.createForm',
        layout: '/admin',
        path: '/products/:productId/create-form',
        component: <Form />,
        employeePermission: 'edit-forms',
    },
    {
        dontShow: true,
        name: 'Landing Page Builder',
        nameKey: 'routes.landingPageBuilder',
        layout: '/admin',
        path: '/products/:productId/landing-page',
        component: <LandingPageBuilder />,
        permission: 'premium',
        employeePermission: 'edit-forms',
    },
    {
        dontShow: true,
        name: 'Edit Product',
        nameKey: 'routes.editProduct',
        layout: '/admin',
        path: '/edit-product/:id',
        component: <ProductForm />,
        employeePermission: 'edit-products',
    },
    {
        dontShow: true,
        name: 'Create Product',
        nameKey: 'routes.createProduct',
        layout: '/admin',
        path: '/create-product',
        component: <ProductForm />,
        employeePermission: 'edit-products',
    },
    {
        dontShow: true,
        name: 'Duplicate Product',
        nameKey: 'routes.duplicateProduct',
        layout: '/admin',
        path: '/duplicate-product/:id',
        component: <ProductForm />,
        employeePermission: 'edit-products',
    },
    {
        name: 'Team',
        nameKey: 'routes.team',
        layout: '/admin',
        icon: <Icon as={MdBarChart} width="20px" height="20px" color="inherit"/>,
        path: '/team',
        component: <EmployeesModule/>,
        permission: 'have-employees',
        employeePermission: 'no',
    },
    {
        name: 'ROAS',
        nameKey: 'routes.roas',
        layout: '/admin',
        path: '/roas',
        icon: <Icon as={MdLock} width="20px" height="20px" color="inherit"/>,
        component: <Roas/>,
        permission: 'basic-default',
        employeePermission: 'access-roas-page',
    },
    {
        name: 'Calculator',
        nameKey: 'routes.calculator',
        layout: '/admin',
        path: '/calculator',
        icon: <Icon as={MdMoney} width="20px" height="20px" color="inherit"/>,
        component: <Calculator/>,
        permission: 'premium',
        employeePermission: 'no',
    },
    {
        dontShow: true,
        name: 'Settings',
        nameKey: 'routes.settings',
        layout: '/admin',
        path: '/settings',
        icon: <Icon as={MdLock} width="20px" height="20px" color="inherit"/>,
        component: <Settings/>,
        permission: 'basic-default',
        employeePermission: 'no',
    },
    {
        dontShow: true,
        name: 'Change Password',
        nameKey: 'routes.changePassword',
        layout: '/admin',
        path: '/change-password',
        icon: <Icon as={MdLock} width="20px" height="20px" color="inherit"/>,
        component: <ChangePassword/>,
        permission: 'basic-default',
    },
    {
        dontShow: true,
        name: 'Link Account',
        nameKey: 'routes.linkAccount',
        layout: '/admin',
        path: '/link-account',
        icon: <Icon as={MdLock} width="20px" height="20px" color="inherit"/>,
        component: <LinkAccount/>,
        permission: 'premium',
        employeePermission: 'no',
    },
    {
        dontShow: true,
        name: 'Accept Linking',
        nameKey: 'routes.acceptLinking',
        layout: '/admin',
        path: '/accept/:token',
        icon: <Icon as={MdLock} width="20px" height="20px" color="inherit"/>,
        component: <AcceptAccount/>,
        permission: 'premium',
        employeePermission: 'no',
    },
    {
        dontShow: true,
        name: 'Forbidden',
        nameKey: 'routes.forbidden',
        layout: '/admin',
        path: '/forbidden',
        component: <Forbidden/>,
    },
    {
        dontShow: true,
        name: 'Sign In',
        nameKey: 'routes.signIn',
        layout: '/auth',
        path: '/sign-in',
        icon: <Icon as={MdLock} width="20px" height="20px" color="inherit"/>,
        component: <SignInCentered/>,
    },
];

export default routes;
